module.exports = __webpack_public_path__ + "static/img/home-top-background.fab2bb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/home-top-background.jpg
// module id = fEYI
// module chunks = 2